module.exports = __webpack_public_path__ + "img/P3.cbc51bfc.png";